module.exports = __webpack_public_path__ + "static/media/add.a90297b0.svg";